import { render, staticRenderFns } from "./SideBarForMobile.vue?vue&type=template&id=bfedd420&scoped=true&"
import script from "./SideBarForMobile.vue?vue&type=script&lang=js&"
export * from "./SideBarForMobile.vue?vue&type=script&lang=js&"
import style0 from "./SideBarForMobile.vue?vue&type=style&index=0&id=bfedd420&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfedd420",
  null
  
)

export default component.exports